import React from "react";
import { css } from "@emotion/react";
import { searchCategories } from "main/javascripts/constants/SearchCategories";
import { SearchHotel } from "main/javascripts/features/post/components/SearchHotel";
import { SearchFlight } from "main/javascripts/features/post/components/SearchFlight";
import { SearchDynamicPackage } from "main/javascripts/features/post/components/SearchDynamicPackage";
import {
  accentColor,
  shadowColor,
} from "main/javascripts/styles/base/colorStyle";
import { InPostSearchCategoryTab } from "./InPostSearchCategoryTab";
import { useAppSelector } from "../../../store";
import { searchCategorySelector } from "../../search/searchPageSlice";
import { postSelector } from "../postSlice";

export interface IProps {}

export const InPostSearchForm: React.FC = (): React.ReactElement => {
  const searchCategory = useAppSelector(searchCategorySelector);
  const post = useAppSelector(postSelector);

  const renderSearchType = () => {
    switch (searchCategory) {
      case searchCategories.hotel:
        return <SearchHotel isCompact={true} />;
      case searchCategories.flight:
        return <SearchFlight isCompact={true} />;
      case searchCategories.dynamicPackage:
        return <SearchDynamicPackage isCompact={true} />;
      default:
        return <SearchHotel isCompact={true} />;
    }
  };

  if (!post.searchTypes || post.searchTypes.length === 0) {
    return null;
  }

  return (
    <div css={blockStyle}>
      <div css={innerStyle}>
        <div css={categoryTabStyle}>
          <InPostSearchCategoryTab borderStyleKey="noRound" />
        </div>
        {renderSearchType()}
      </div>
    </div>
  );
};

const blockStyle = css`
  max-width: 500px;
  margin: 0 auto 0;
`;
const innerStyle = css`
  border-radius: 10px;
  border: 1px solid ${accentColor.primaryColor};
  box-shadow: 0 0.125rem 1rem ${shadowColor.soft};
  overflow: hidden;
`;
const categoryTabStyle = css`
  border-bottom: 1px solid ${accentColor.primaryColor};
`;
